module.exports = __webpack_public_path__ + "img/purple-rectangle-table-6.cfb243cc.png";